import { createContext, useContext } from 'react';

/** Shape of a mock uploading file for the demo queue */
export interface DemoUploadingFile {
  fileName: string;
  fileSize: number;
  progress: number;
  status: 'uploading' | 'processing' | 'completed' | 'error';
  message?: string;
}

/** Demo state exposed to UploadPage via context */
export interface UploadDemoState {
  /** Whether demo is active (any phase) */
  active: boolean;
  /** Simulated active tab */
  activeTab?: string;
  /** Mock files in the queue sidebar */
  uploadingFiles?: DemoUploadingFile[];
  /** Which card to show drag-over animation on */
  dragOverCard?: 'data' | 'pdf' | 'image' | 'media' | null;
}

export const UploadDemoCtx = createContext<UploadDemoState | null>(null);

/** Returns demo state if on demo subdomain, null otherwise */
export function useUploadDemoContext(): UploadDemoState | null {
  return useContext(UploadDemoCtx);
}
